import { Google } from '../analytics/index.js';
import { sanitizeValue } from './helpers/index.js';

/**
 * @summary Sends GA event for CarBravo CTA
 * @events event2
 */

export async function carBravoCTAClick(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  const {
    data = {},
    dataLayer
  } = metadata;
  const {
    ctaCopy,
    selectedItem
  } = data;
  Google.sendClickEvent({
    eventElement: 'search-car',
    eventResult: `cta::srp::${ctaCopy}`,
    eventAction: 'click',
    eventNonInteractive: false,
    eventData: {
      vehicle: {
        catalog: dataLayer.catalog,
        // CD113
        makeId: sanitizeValue(selectedItem.code),
        // CD118
        makeName: sanitizeValue(selectedItem.makeLabel) // CD119
      }
    }
  }, option);
  return {};
}
export default {
  carBravoCTAClick
};